import { isLoading, isLoaded } from './saga';
import { ApiConstants } from '../constants/actions';

export const addresses = (state): boolean => state.apiAddresses.isLoading;

const isLoadingContacts = isLoading([ApiConstants.LOAD_CONTACTS]);
export const contacts = (state): boolean => isLoadingContacts(state);

const isLoadingCountries = isLoading([ApiConstants.LOAD_COUNTRIES]);
export const countries = (state): boolean => isLoadingCountries(state);

const isLoadingCompanyInfo = isLoading([
  ApiConstants.LOAD_COUNTRIES,
  ApiConstants.LOAD_USER_COMPANY
]);
export const companyInfo = (state): boolean => isLoadingCompanyInfo(state);

export const reorderData = (state, orderId?: string): boolean => {
  const requiredDataLoading = !isLoaded([
    ApiConstants.LOAD_USER_COMPANY,
    ApiConstants.LOAD_VOUCHERS,
    ApiConstants.LOAD_ORDER_FEES,
    ApiConstants.LOAD_SETTINGS
  ])(state);

  const reorderLoading = isLoading([ApiConstants.LOAD_REORDER_DATA])(state);

  return requiredDataLoading || reorderLoading;
};

const isDisablePayment = isLoading([ApiConstants.CREATE_NEW_PAYMENT]);
export const disablePayment = (state): boolean => isDisablePayment(state);

const isLoadingOrderData = isLoading([
  ApiConstants.CHECK_USERNAME_AVAILABILITY,
  ApiConstants.LOAD_VOUCHERS,
  ApiConstants.LOAD_ORDER_FEES,
  ApiConstants.LOAD_SETTINGS
]);
export const orderData = (state): boolean => isLoadingOrderData(state);

const isLoadingSignUp = isLoading([
  ApiConstants.SIGN_UP,
  ApiConstants.CHECK_USERNAME_AVAILABILITY,
  ApiConstants.LOGIN_ACTION
]);
export const signUp = (state): boolean => isLoadingSignUp(state);

const isLoadingChangePassword = isLoading([ApiConstants.CHANGE_PASSWORD]);
export const changePassword = (state): boolean =>
  isLoadingChangePassword(state);

const isLoadingOrderPayment = isLoading([
  ApiConstants.ADD_NEW_PAYMENT_TO_VOUCHER
]);
export const orderPayment = (state): boolean => isLoadingOrderPayment(state);

const isLoadingCompanyAccounts = isLoading([
  ApiConstants.LOAD_COMPANY_ACCOUNTS
]);
export const loadCompanyAccounts = (state): boolean =>
  isLoadingCompanyAccounts(state);
